module.exports = __webpack_public_path__ + "06_mole.8251dfb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer2/06_mole.png
// module id = VX/i
// module chunks = 0